/*
 * @Author: your name
 * @Date: 2021-12-30 11:13:58
 * @LastEditTime: 2021-12-31 10:50:13
 * @LastEditors: Please set LastEditors
 * @Description: 创建地图
 * @FilePath: \smart-community\src\views\map\SatelliteMap\js\CreateMap.js
 */

import "ol/ol.css";
import Map from "ol/Map";
import View from "ol/View";
import Tile from "ol/layer/Tile";
import TileGrid from "ol/tilegrid/TileGrid";
import { XYZ } from "ol/source";
import { FullScreen, defaults as defaultControls } from "ol/control";
import { defaults } from "ol/interaction";
// DragRotateAndZoom
import handleCoordinates from "./handleCoordinates";
import { boundingExtent } from "ol/extent";

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import Polyline from 'ol/format/Polyline';
import VectorSource from 'ol/source/Vector';
import chongqing from '@/utils/chongqing.json';
import {
  Circle as CircleStyle,
  Fill,
  Icon,
  Stroke,
  Style,
} from 'ol/style';
import { Tile as TileLayer, Vector as VectorLayer } from 'ol/layer';
let renderTimes = 0;
const { setPoint, coordinatesGPS } = handleCoordinates();
class CreateMap {
  // constructor() {}
  init(target, callback) {
    const { projection } = coordinatesGPS();
    // const currenMap = window.tilesFun('2DMap')
    // const tilesDir = currenMap;
    const tilesDir = window.bmapcfg.tiles_dir;
    const imgext = window.bmapcfg.imgext;

    var bmercResolutions = new Array(19);
    for (var i = 0; i < 19; ++i) {
      bmercResolutions[i] = Math.pow(2, 18 - i);
    }
    const tileGrid = new TileGrid({
      resolutions: bmercResolutions,
      origin: [0, 0]
    });
    // 创建百度地图的数据源
    var baiduSource = new XYZ({
      projection: projection,
      tileGrid: tileGrid,
      maxZoom: window.mapView.maxZoom,
      tileUrlFunction: function(tileCoord) {
        var x = tileCoord[1];
        var y = -tileCoord[2] - 1;
        var z = tileCoord[0];

        return (
          `${tilesDir}` + z + "/" + Math.abs(x) + "/" + Math.abs(y) + imgext
        );
      }
    });
    const mapLayers = new Tile({
      source: baiduSource
    });
    // 限制范围
    const extent = [
      7521710.275907801,
      1089748.66288583074,
      15641596.651638819,
      7293274.359150837
    ];
    const mapView = new View({
      center: setPoint(window.mapView.center),
      zoom: window.mapView.zoom,
      minZoom: window.mapView.minZoom,
      maxZoom: window.mapView.maxZoom,
      projection,
      extent
    });
    const map = new Map({
      target: target,
      layers: [mapLayers],
      view: mapView,
      controls: defaultControls().extend([new FullScreen()]),
      interactions: defaults({
        zoom: true,
        rotate: true,
        attribution: false,
        altShiftDragRotate: true, // 是否需要 Alt-Shift-drag 旋转。
        doubleClickZoom: false, // 取消双击放大功能交互
        shiftDragZoom: true // 取消shift+wheel左键拖动交互 拖动缩放
      })
    });
    map.on("rendercomplete", function(evt) {
      ++renderTimes;
      if (renderTimes === 1) {
        callback && callback();
      }
    });
    map.on("pointermove", function(evt) {
      const pixel = map.getEventPixel(evt.originalEvent)
      const hit = map.hasFeatureAtPixel(pixel)
      map.getTarget().style.cursor = hit ? "pointer" : ''
    });


    return {
      map,
      mapLayers,
      mapView
    };
  }
}
export default CreateMap;